import React, { FC, PropsWithChildren } from 'react';

import { InView } from 'react-intersection-observer';

import ABTest from './ab-test';
import { ABTesting } from '../../types/types';

const ABTestBranch: FC<PropsWithChildren<ABTesting.BranchProps>> = ({
  as: Element = 'div',
  branch,
  children,
  className,
}) => (
  <ABTest.Context.Consumer>
    {({ branch: testBranch, trigger, triggerCurrentTest }) =>
      branch === testBranch ? (
        trigger === 'visible' ? (
          <InView
            triggerOnce
            as={Element}
            css={{ '&:empty': { display: 'none' } }}
            onChange={inView => inView && triggerCurrentTest()}
          >
            {children}
          </InView>
        ) : (
          <Element className={className}>{children}</Element>
        )
      ) : null
    }
  </ABTest.Context.Consumer>
);

export { ABTestBranch };
export default ABTestBranch;
